import React from "react";

const Services = () => {
  return (
    <div className="page-container services-page">
      <h1 className="main-heading">Our Services</h1>
      <div className="services-grid">
        <div className="service-section">
          <h2 className="sub-heading">Customer Support</h2>
          <ul className="service-list">
            <li>
              The service providing team at Indelect consists of well qualified,
              dexterous, and trained engineers and technicians. Indelect offers
              flawless customer support services.
            </li>
          </ul>
        </div>
        <div className="service-section">
          <h2 className="sub-heading">X-ray Equipments</h2>
          <ul className="service-list">
            <li>Installation and calibration of the equipments</li>
            <li>Periodical maintenance during the warranty period</li>
            <li>Periodical maintenance on AMCs</li>
            <li>Services on calls</li>
          </ul>
        </div>
        <div className="service-section">
          <h2 className="sub-heading">Frameless Stereotactic Pointers</h2>
          <ul className="service-list">
            <li>Working demonstration using pumpkin head</li>
            <li>Installation of the software and equipments</li>
            <li>Support during surgery cases during warranty period</li>
            <li>Support for cases on calls</li>
          </ul>
        </div>
        <div className="service-section">
          <h2 className="sub-heading">Quality Assurance Services</h2>
          <ul className="service-list">
            <li>Quality Assurance and Performance Test</li>
            <li>Assistance to get AERB License and Registration</li>
            <li>Designing of room layout as per AERB guidelines</li>
            <li>Surveillance protection and guidance for procedures</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Services;
